import { Component, effect, inject, input, OnInit, ViewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button'
import { MatTableModule, MatRow, MatTableDataSource } from '@angular/material/table'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialog } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckbox } from '@angular/material/checkbox'


import { CommonModule, DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { NgFor, NgIf } from '@angular/common';
import { style, state, trigger, transition, animate } from '@angular/animations';
import { FeedstockService } from '../../../../services/feedstockservice';
import { LabChemistryList } from '../../../../interfaces/labchemistrymodel';
import { LabMetalsList } from '../../../../interfaces/labmetalsmodel';
import { FilterState } from '../../../../interfaces/generatorsmodel';
import { AddeditMetalsComponent } from './addedit-metals/addedit-metals.component';
import { ConfirmationDialogData, ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { NotificationService } from '../../../../services/notificationservice';
import { RolePermissionsService } from '../../../../services/role-permissions.service';
import { LoadScheduleControlFlags, ScreenName } from '../../../../interfaces/securityPermissions';
import { RoleService } from '../../../../services/role.service';

@Component({
  selector: 'app-metals',
  imports: [MatIcon, MatTableModule, MatRow, MatPaginatorModule, MatSortModule, MatFormFieldModule,
    MatInputModule, MatButtonModule, MatSelectModule, MatDatepickerModule,
    MatMenuModule, MatProgressBarModule, MatProgressSpinnerModule, MatCardModule, CommonModule],
  templateUrl: './metals.component.html',
  styleUrl: './metals.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class MetalsComponent implements OnInit {
  permissions = inject(RolePermissionsService);
  displayedColumns: string[] = ['actions','id','m_LabName', 'm_LabreportID', 'm_DateSampled', 'm_DateTested','testingTypeName' , 'status',
    'ts','tS_mg_L','as_Dry','cd_Dry','cr_Dry','co_Dry','cu_Dry','pb_Dry',
    'hg_Dry','mo_Dry','ni_Dry','se_Dry','zn_Dry','as_Wet','cd_Wet','cr_Wet','co_Wet','cu_Wet','pb_Wet',
    'hg_Wet','mo_Wet','ni_Wet','se_Wet','zn_Wet','notes'
  ];
  dataSource = new MatTableDataSource<any>;
  metalsList: LabMetalsList[] = [];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  filterState = input<FilterState | null>(null);
  refreshTrigger = input<number>(0);
  gridSearchText = input<string | null>(null);
  controlPermissions: LoadScheduleControlFlags = new LoadScheduleControlFlags();

  constructor(private _dialog: MatDialog, private fsService: FeedstockService, private datePipe: DatePipe,
    private notificationService: NotificationService,
    private rolesService: RoleService) {
    effect(() => {
      const state = this.filterState();
      const currentRefresh = this.refreshTrigger();
      //if (currentRefresh > 0) {
        if (!state || state.tabIndex !== 10) return;
        const streamid = this.filterState()?.stream?.toString() || '0';
        this.getLabMetalsdata(parseInt(streamid));
      //}
    });
    
    effect(() => {
      const searchText = this.gridSearchText();
      if (this.dataSource) { 
        this.applyGridFilter(searchText ?? '');
      }
    });
    
    effect(() => {
      const currentFilter = this.filterState();
      if (currentFilter) {
        const streamid = currentFilter.stream?.toString() || '0';
        //this.getLabMetalsdata(parseInt(streamid));
      }
    });
  }

  ngOnInit(): void {    
    let roles = this.rolesService.getRolesAsString();
    this.permissions.getRolePermissionsNew(roles, ScreenName.CustomerInfo, 0).subscribe({
      next: (perms: LoadScheduleControlFlags) => {
        this.controlPermissions = perms;
      }
    })
  }

  formatDate(dateString: string | null | undefined): string {
    if (!dateString) {
      return '';
    }
    return this.datePipe.transform(dateString, 'MM/dd/yyyy') || '';
  }

  getLabMetalsdata(streamid: number) {
    this.fsService.getMetalsList(streamid).subscribe(
      {
        next: (res: LabMetalsList[]) => {
          console.log("metals data", res);
          this.metalsList = res;
          
          if (this.dataSource) {
            this.dataSource.data = this.metalsList;
          } else {
            this.dataSource = new MatTableDataSource(this.metalsList);
          }
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
  
          const currentSearchText = this.gridSearchText();
          if (currentSearchText) {
              this.applyGridFilter(currentSearchText);
          }
        }
      }
    );
  }
  
  applyGridFilter(filterText: string) {
    const filterValue = filterText.trim().toLowerCase();
    this.dataSource.filter = filterValue;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  getStatusCellClass(row: LabMetalsList): { [key: string]: boolean } {  
    const isFailed = row.status === "Fail";
    return {
      orangeBG: isFailed
    };
  }

  onOpen(row: LabMetalsList, task: string) {
    const genId = this.filterState()?.generator?.toString() || '0';
    const dialogRef = this._dialog.open(AddeditMetalsComponent, {
      data: { 
        inputData: row,
        streamId: this.filterState()?.stream || 0,
        genId: parseInt(genId),
        task: task,
        canSave: this.controlPermissions.editMetal
      },
      disableClose: true,
       width: '900px',
       maxWidth: '1000px',
       maxHeight: '90vh'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const streamid = this.filterState()?.stream?.toString() || '0';
        this.getLabMetalsdata(parseInt(streamid));
        this.notificationService.show(`Metal lab data saved successfully.`, 'Success');
      }
    });
  }

  onDelete(id: number, name: string) {
    const dialogData: ConfirmationDialogData = {
      title: 'Confirm Deletion',
      message: `Are you sure you want to delete metal lab: ${name}?`,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: 'warn'
    };

    this._dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      panelClass: 'delete-confirmation-dialog',
      data: dialogData,
      disableClose: true
    }).afterClosed().subscribe(result => {
      if (result) {
        if (id !== null && id !== undefined) {
          const genId = this.filterState()?.generator?.toString() || '0';
          this.fsService.deleteMetal(id).subscribe({
            next: () => {
              this.dataSource.data = this.dataSource.data.filter(item => item.id !== id);
              this.notificationService.show('Metal lab data deleted successfully.', 'Success');
            }
          });
        }
      }
    });
  }

  openContextmenu(data: any) {

  }
}
